import { c as P, u as H, r as R, s as We, w as k, g as lt, o as at, a as Q, F as Ie, m as pe, t as Re, b as Ve, n as ct, p as ut, d as ft, e as dt, h as ne, U as mt, f as ve, T as pt, i as vt, S as gt, j as ht, k as wt, l as yt, q as xt, v as bt, P as Ct, x as Pe, y as Ot, z as At, A as ge, B as Tt, C as St, D as Et, E as Rt, G as Pt, H as Ft, I as Lt } from "./core-93d86384.js";
const ze = ["top", "right", "bottom", "left"], Fe = ["start", "end"], Le = /* @__PURE__ */ ze.reduce((e, t) => e.concat(t, t + "-" + Fe[0], t + "-" + Fe[1]), []), Z = Math.min, q = Math.max, ae = Math.round, le = Math.floor, X = (e) => ({
  x: e,
  y: e
}), Bt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Dt = {
  start: "end",
  end: "start"
};
function ye(e, t, n) {
  return q(e, Z(t, n));
}
function K(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function z(e) {
  return e.split("-")[0];
}
function M(e) {
  return e.split("-")[1];
}
function Ue(e) {
  return e === "x" ? "y" : "x";
}
function be(e) {
  return e === "y" ? "height" : "width";
}
function de(e) {
  return ["top", "bottom"].includes(z(e)) ? "y" : "x";
}
function Ce(e) {
  return Ue(de(e));
}
function Xe(e, t, n) {
  n === void 0 && (n = !1);
  const i = M(e), o = Ce(e), r = be(o);
  let s = o === "x" ? i === (n ? "end" : "start") ? "right" : "left" : i === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (s = ue(s)), [s, ue(s)];
}
function Nt(e) {
  const t = ue(e);
  return [ce(e), t, ce(t)];
}
function ce(e) {
  return e.replace(/start|end/g, (t) => Dt[t]);
}
function $t(e, t, n) {
  const i = ["left", "right"], o = ["right", "left"], r = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : i : t ? i : o;
    case "left":
    case "right":
      return t ? r : s;
    default:
      return [];
  }
}
function kt(e, t, n, i) {
  const o = M(e);
  let r = $t(z(e), n === "start", i);
  return o && (r = r.map((s) => s + "-" + o), t && (r = r.concat(r.map(ce)))), r;
}
function ue(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Bt[t]);
}
function jt(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ye(e) {
  return typeof e != "number" ? jt(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function fe(e) {
  const {
    x: t,
    y: n,
    width: i,
    height: o
  } = e;
  return {
    width: i,
    height: o,
    top: n,
    left: t,
    right: t + i,
    bottom: n + o,
    x: t,
    y: n
  };
}
function Be(e, t, n) {
  let {
    reference: i,
    floating: o
  } = e;
  const r = de(t), s = Ce(t), l = be(s), u = z(t), c = r === "y", f = i.x + i.width / 2 - o.width / 2, m = i.y + i.height / 2 - o.height / 2, w = i[l] / 2 - o[l] / 2;
  let d;
  switch (u) {
    case "top":
      d = {
        x: f,
        y: i.y - o.height
      };
      break;
    case "bottom":
      d = {
        x: f,
        y: i.y + i.height
      };
      break;
    case "right":
      d = {
        x: i.x + i.width,
        y: m
      };
      break;
    case "left":
      d = {
        x: i.x - o.width,
        y: m
      };
      break;
    default:
      d = {
        x: i.x,
        y: i.y
      };
  }
  switch (M(t)) {
    case "start":
      d[s] -= w * (n && c ? -1 : 1);
      break;
    case "end":
      d[s] += w * (n && c ? -1 : 1);
      break;
  }
  return d;
}
const _t = async (e, t, n) => {
  const {
    placement: i = "bottom",
    strategy: o = "absolute",
    middleware: r = [],
    platform: s
  } = n, l = r.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let c = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: f,
    y: m
  } = Be(c, i, u), w = i, d = {}, a = 0;
  for (let v = 0; v < l.length; v++) {
    const {
      name: g,
      fn: h
    } = l[v], {
      x: y,
      y: b,
      data: C,
      reset: O
    } = await h({
      x: f,
      y: m,
      initialPlacement: i,
      placement: w,
      strategy: o,
      middlewareData: d,
      rects: c,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = y ?? f, m = b ?? m, d = {
      ...d,
      [g]: {
        ...d[g],
        ...C
      }
    }, O && a <= 50 && (a++, typeof O == "object" && (O.placement && (w = O.placement), O.rects && (c = O.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : O.rects), {
      x: f,
      y: m
    } = Be(c, w, u)), v = -1);
  }
  return {
    x: f,
    y: m,
    placement: w,
    strategy: o,
    middlewareData: d
  };
};
async function oe(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: i,
    y: o,
    platform: r,
    rects: s,
    elements: l,
    strategy: u
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: m = "floating",
    altBoundary: w = !1,
    padding: d = 0
  } = K(t, e), a = Ye(d), g = l[w ? m === "floating" ? "reference" : "floating" : m], h = fe(await r.getClippingRect({
    element: (n = await (r.isElement == null ? void 0 : r.isElement(g))) == null || n ? g : g.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: u
  })), y = m === "floating" ? {
    x: i,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, b = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(l.floating)), C = await (r.isElement == null ? void 0 : r.isElement(b)) ? await (r.getScale == null ? void 0 : r.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, O = fe(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: y,
    offsetParent: b,
    strategy: u
  }) : y);
  return {
    top: (h.top - O.top + a.top) / C.y,
    bottom: (O.bottom - h.bottom + a.bottom) / C.y,
    left: (h.left - O.left + a.left) / C.x,
    right: (O.right - h.right + a.right) / C.x
  };
}
const Ht = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: i,
      placement: o,
      rects: r,
      platform: s,
      elements: l,
      middlewareData: u
    } = t, {
      element: c,
      padding: f = 0
    } = K(e, t) || {};
    if (c == null)
      return {};
    const m = Ye(f), w = {
      x: n,
      y: i
    }, d = Ce(o), a = be(d), v = await s.getDimensions(c), g = d === "y", h = g ? "top" : "left", y = g ? "bottom" : "right", b = g ? "clientHeight" : "clientWidth", C = r.reference[a] + r.reference[d] - w[d] - r.floating[a], O = w[d] - r.reference[d], A = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let p = A ? A[b] : 0;
    (!p || !await (s.isElement == null ? void 0 : s.isElement(A))) && (p = l.floating[b] || r.floating[a]);
    const T = C / 2 - O / 2, F = p / 2 - v[a] / 2 - 1, E = Z(m[h], F), B = Z(m[y], F), S = E, D = p - v[a] - B, L = p / 2 - v[a] / 2 + T, $ = ye(S, L, D), _ = !u.arrow && M(o) != null && L !== $ && r.reference[a] / 2 - (L < S ? E : B) - v[a] / 2 < 0, V = _ ? L < S ? L - S : L - D : 0;
    return {
      [d]: w[d] + V,
      data: {
        [d]: $,
        centerOffset: L - $ - V,
        ..._ && {
          alignmentOffset: V
        }
      },
      reset: _
    };
  }
});
function Mt(e, t, n) {
  return (e ? [...n.filter((o) => M(o) === e), ...n.filter((o) => M(o) !== e)] : n.filter((o) => z(o) === o)).filter((o) => e ? M(o) === e || (t ? ce(o) !== o : !1) : !0);
}
const Wt = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var n, i, o;
      const {
        rects: r,
        middlewareData: s,
        placement: l,
        platform: u,
        elements: c
      } = t, {
        crossAxis: f = !1,
        alignment: m,
        allowedPlacements: w = Le,
        autoAlignment: d = !0,
        ...a
      } = K(e, t), v = m !== void 0 || w === Le ? Mt(m || null, d, w) : w, g = await oe(t, a), h = ((n = s.autoPlacement) == null ? void 0 : n.index) || 0, y = v[h];
      if (y == null)
        return {};
      const b = Xe(y, r, await (u.isRTL == null ? void 0 : u.isRTL(c.floating)));
      if (l !== y)
        return {
          reset: {
            placement: v[0]
          }
        };
      const C = [g[z(y)], g[b[0]], g[b[1]]], O = [...((i = s.autoPlacement) == null ? void 0 : i.overflows) || [], {
        placement: y,
        overflows: C
      }], A = v[h + 1];
      if (A)
        return {
          data: {
            index: h + 1,
            overflows: O
          },
          reset: {
            placement: A
          }
        };
      const p = O.map((E) => {
        const B = M(E.placement);
        return [E.placement, B && f ? (
          // Check along the mainAxis and main crossAxis side.
          E.overflows.slice(0, 2).reduce((S, D) => S + D, 0)
        ) : (
          // Check only the mainAxis.
          E.overflows[0]
        ), E.overflows];
      }).sort((E, B) => E[1] - B[1]), F = ((o = p.filter((E) => E[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        M(E[0]) ? 2 : 3
      ).every((B) => B <= 0))[0]) == null ? void 0 : o[0]) || p[0][0];
      return F !== l ? {
        data: {
          index: h + 1,
          overflows: O
        },
        reset: {
          placement: F
        }
      } : {};
    }
  };
}, It = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, i;
      const {
        placement: o,
        middlewareData: r,
        rects: s,
        initialPlacement: l,
        platform: u,
        elements: c
      } = t, {
        mainAxis: f = !0,
        crossAxis: m = !0,
        fallbackPlacements: w,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: a = "none",
        flipAlignment: v = !0,
        ...g
      } = K(e, t);
      if ((n = r.arrow) != null && n.alignmentOffset)
        return {};
      const h = z(o), y = z(l) === l, b = await (u.isRTL == null ? void 0 : u.isRTL(c.floating)), C = w || (y || !v ? [ue(l)] : Nt(l));
      !w && a !== "none" && C.push(...kt(l, v, a, b));
      const O = [l, ...C], A = await oe(t, g), p = [];
      let T = ((i = r.flip) == null ? void 0 : i.overflows) || [];
      if (f && p.push(A[h]), m) {
        const S = Xe(o, s, b);
        p.push(A[S[0]], A[S[1]]);
      }
      if (T = [...T, {
        placement: o,
        overflows: p
      }], !p.every((S) => S <= 0)) {
        var F, E;
        const S = (((F = r.flip) == null ? void 0 : F.index) || 0) + 1, D = O[S];
        if (D)
          return {
            data: {
              index: S,
              overflows: T
            },
            reset: {
              placement: D
            }
          };
        let L = (E = T.filter(($) => $.overflows[0] <= 0).sort(($, _) => $.overflows[1] - _.overflows[1])[0]) == null ? void 0 : E.placement;
        if (!L)
          switch (d) {
            case "bestFit": {
              var B;
              const $ = (B = T.map((_) => [_.placement, _.overflows.filter((V) => V > 0).reduce((V, st) => V + st, 0)]).sort((_, V) => _[1] - V[1])[0]) == null ? void 0 : B[0];
              $ && (L = $);
              break;
            }
            case "initialPlacement":
              L = l;
              break;
          }
        if (o !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function De(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Ne(e) {
  return ze.some((t) => e[t] >= 0);
}
const Vt = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: i = "referenceHidden",
        ...o
      } = K(e, t);
      switch (i) {
        case "referenceHidden": {
          const r = await oe(t, {
            ...o,
            elementContext: "reference"
          }), s = De(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Ne(s)
            }
          };
        }
        case "escaped": {
          const r = await oe(t, {
            ...o,
            altBoundary: !0
          }), s = De(r, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Ne(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function zt(e, t) {
  const {
    placement: n,
    platform: i,
    elements: o
  } = e, r = await (i.isRTL == null ? void 0 : i.isRTL(o.floating)), s = z(n), l = M(n), u = de(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, f = r && u ? -1 : 1, m = K(t, e);
  let {
    mainAxis: w,
    crossAxis: d,
    alignmentAxis: a
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...m
  };
  return l && typeof a == "number" && (d = l === "end" ? a * -1 : a), u ? {
    x: d * f,
    y: w * c
  } : {
    x: w * c,
    y: d * f
  };
}
const Ut = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, i;
      const {
        x: o,
        y: r,
        placement: s,
        middlewareData: l
      } = t, u = await zt(t, e);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (i = l.arrow) != null && i.alignmentOffset ? {} : {
        x: o + u.x,
        y: r + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, Xt = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: i,
        placement: o
      } = t, {
        mainAxis: r = !0,
        crossAxis: s = !1,
        limiter: l = {
          fn: (g) => {
            let {
              x: h,
              y
            } = g;
            return {
              x: h,
              y
            };
          }
        },
        ...u
      } = K(e, t), c = {
        x: n,
        y: i
      }, f = await oe(t, u), m = de(z(o)), w = Ue(m);
      let d = c[w], a = c[m];
      if (r) {
        const g = w === "y" ? "top" : "left", h = w === "y" ? "bottom" : "right", y = d + f[g], b = d - f[h];
        d = ye(y, d, b);
      }
      if (s) {
        const g = m === "y" ? "top" : "left", h = m === "y" ? "bottom" : "right", y = a + f[g], b = a - f[h];
        a = ye(y, a, b);
      }
      const v = l.fn({
        ...t,
        [w]: d,
        [m]: a
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - i
        }
      };
    }
  };
};
function te(e) {
  return qe(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function N(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function U(e) {
  var t;
  return (t = (qe(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function qe(e) {
  return e instanceof Node || e instanceof N(e).Node;
}
function W(e) {
  return e instanceof Element || e instanceof N(e).Element;
}
function I(e) {
  return e instanceof HTMLElement || e instanceof N(e).HTMLElement;
}
function $e(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof N(e).ShadowRoot;
}
function se(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: i,
    display: o
  } = j(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + i + n) && !["inline", "contents"].includes(o);
}
function Yt(e) {
  return ["table", "td", "th"].includes(te(e));
}
function Oe(e) {
  const t = Ae(), n = j(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((i) => (n.willChange || "").includes(i)) || ["paint", "layout", "strict", "content"].some((i) => (n.contain || "").includes(i));
}
function qt(e) {
  let t = Y(e);
  for (; I(t) && !ee(t); ) {
    if (Oe(t))
      return t;
    t = Y(t);
  }
  return null;
}
function Ae() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ee(e) {
  return ["html", "body", "#document"].includes(te(e));
}
function j(e) {
  return N(e).getComputedStyle(e);
}
function me(e) {
  return W(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Y(e) {
  if (te(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    $e(e) && e.host || // Fallback.
    U(e)
  );
  return $e(t) ? t.host : t;
}
function Ge(e) {
  const t = Y(e);
  return ee(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : I(t) && se(t) ? t : Ge(t);
}
function ie(e, t, n) {
  var i;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Ge(e), r = o === ((i = e.ownerDocument) == null ? void 0 : i.body), s = N(o);
  return r ? t.concat(s, s.visualViewport || [], se(o) ? o : [], s.frameElement && n ? ie(s.frameElement) : []) : t.concat(o, ie(o, [], n));
}
function Ke(e) {
  const t = j(e);
  let n = parseFloat(t.width) || 0, i = parseFloat(t.height) || 0;
  const o = I(e), r = o ? e.offsetWidth : n, s = o ? e.offsetHeight : i, l = ae(n) !== r || ae(i) !== s;
  return l && (n = r, i = s), {
    width: n,
    height: i,
    $: l
  };
}
function Te(e) {
  return W(e) ? e : e.contextElement;
}
function J(e) {
  const t = Te(e);
  if (!I(t))
    return X(1);
  const n = t.getBoundingClientRect(), {
    width: i,
    height: o,
    $: r
  } = Ke(t);
  let s = (r ? ae(n.width) : n.width) / i, l = (r ? ae(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const Gt = /* @__PURE__ */ X(0);
function Qe(e) {
  const t = N(e);
  return !Ae() || !t.visualViewport ? Gt : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Kt(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== N(e) ? !1 : t;
}
function G(e, t, n, i) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), r = Te(e);
  let s = X(1);
  t && (i ? W(i) && (s = J(i)) : s = J(e));
  const l = Kt(r, n, i) ? Qe(r) : X(0);
  let u = (o.left + l.x) / s.x, c = (o.top + l.y) / s.y, f = o.width / s.x, m = o.height / s.y;
  if (r) {
    const w = N(r), d = i && W(i) ? N(i) : i;
    let a = w, v = a.frameElement;
    for (; v && i && d !== a; ) {
      const g = J(v), h = v.getBoundingClientRect(), y = j(v), b = h.left + (v.clientLeft + parseFloat(y.paddingLeft)) * g.x, C = h.top + (v.clientTop + parseFloat(y.paddingTop)) * g.y;
      u *= g.x, c *= g.y, f *= g.x, m *= g.y, u += b, c += C, a = N(v), v = a.frameElement;
    }
  }
  return fe({
    width: f,
    height: m,
    x: u,
    y: c
  });
}
const Qt = [":popover-open", ":modal"];
function Se(e) {
  return Qt.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Jt(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: i,
    strategy: o
  } = e;
  const r = o === "fixed", s = U(i), l = t ? Se(t.floating) : !1;
  if (i === s || l && r)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = X(1);
  const f = X(0), m = I(i);
  if ((m || !m && !r) && ((te(i) !== "body" || se(s)) && (u = me(i)), I(i))) {
    const w = G(i);
    c = J(i), f.x = w.x + i.clientLeft, f.y = w.y + i.clientTop;
  }
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - u.scrollLeft * c.x + f.x,
    y: n.y * c.y - u.scrollTop * c.y + f.y
  };
}
function Zt(e) {
  return Array.from(e.getClientRects());
}
function Je(e) {
  return G(U(e)).left + me(e).scrollLeft;
}
function en(e) {
  const t = U(e), n = me(e), i = e.ownerDocument.body, o = q(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth), r = q(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight);
  let s = -n.scrollLeft + Je(e);
  const l = -n.scrollTop;
  return j(i).direction === "rtl" && (s += q(t.clientWidth, i.clientWidth) - o), {
    width: o,
    height: r,
    x: s,
    y: l
  };
}
function tn(e, t) {
  const n = N(e), i = U(e), o = n.visualViewport;
  let r = i.clientWidth, s = i.clientHeight, l = 0, u = 0;
  if (o) {
    r = o.width, s = o.height;
    const c = Ae();
    (!c || c && t === "fixed") && (l = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: r,
    height: s,
    x: l,
    y: u
  };
}
function nn(e, t) {
  const n = G(e, !0, t === "fixed"), i = n.top + e.clientTop, o = n.left + e.clientLeft, r = I(e) ? J(e) : X(1), s = e.clientWidth * r.x, l = e.clientHeight * r.y, u = o * r.x, c = i * r.y;
  return {
    width: s,
    height: l,
    x: u,
    y: c
  };
}
function ke(e, t, n) {
  let i;
  if (t === "viewport")
    i = tn(e, n);
  else if (t === "document")
    i = en(U(e));
  else if (W(t))
    i = nn(t, n);
  else {
    const o = Qe(e);
    i = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return fe(i);
}
function Ze(e, t) {
  const n = Y(e);
  return n === t || !W(n) || ee(n) ? !1 : j(n).position === "fixed" || Ze(n, t);
}
function on(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let i = ie(e, [], !1).filter((l) => W(l) && te(l) !== "body"), o = null;
  const r = j(e).position === "fixed";
  let s = r ? Y(e) : e;
  for (; W(s) && !ee(s); ) {
    const l = j(s), u = Oe(s);
    !u && l.position === "fixed" && (o = null), (r ? !u && !o : !u && l.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || se(s) && !u && Ze(e, s)) ? i = i.filter((f) => f !== s) : o = l, s = Y(s);
  }
  return t.set(e, i), i;
}
function rn(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: i,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Se(t) ? [] : on(t, this._c) : [].concat(n), i], l = s[0], u = s.reduce((c, f) => {
    const m = ke(t, f, o);
    return c.top = q(m.top, c.top), c.right = Z(m.right, c.right), c.bottom = Z(m.bottom, c.bottom), c.left = q(m.left, c.left), c;
  }, ke(t, l, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function sn(e) {
  const {
    width: t,
    height: n
  } = Ke(e);
  return {
    width: t,
    height: n
  };
}
function ln(e, t, n) {
  const i = I(t), o = U(t), r = n === "fixed", s = G(e, !0, r, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = X(0);
  if (i || !i && !r)
    if ((te(t) !== "body" || se(o)) && (l = me(t)), i) {
      const m = G(t, !0, r, t);
      u.x = m.x + t.clientLeft, u.y = m.y + t.clientTop;
    } else
      o && (u.x = Je(o));
  const c = s.left + l.scrollLeft - u.x, f = s.top + l.scrollTop - u.y;
  return {
    x: c,
    y: f,
    width: s.width,
    height: s.height
  };
}
function he(e) {
  return j(e).position === "static";
}
function je(e, t) {
  return !I(e) || j(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function et(e, t) {
  const n = N(e);
  if (Se(e))
    return n;
  if (!I(e)) {
    let o = Y(e);
    for (; o && !ee(o); ) {
      if (W(o) && !he(o))
        return o;
      o = Y(o);
    }
    return n;
  }
  let i = je(e, t);
  for (; i && Yt(i) && he(i); )
    i = je(i, t);
  return i && ee(i) && he(i) && !Oe(i) ? n : i || qt(e) || n;
}
const an = async function(e) {
  const t = this.getOffsetParent || et, n = this.getDimensions, i = await n(e.floating);
  return {
    reference: ln(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: i.width,
      height: i.height
    }
  };
};
function cn(e) {
  return j(e).direction === "rtl";
}
const un = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Jt,
  getDocumentElement: U,
  getClippingRect: rn,
  getOffsetParent: et,
  getElementRects: an,
  getClientRects: Zt,
  getDimensions: sn,
  getScale: J,
  isElement: W,
  isRTL: cn
};
function fn(e, t) {
  let n = null, i;
  const o = U(e);
  function r() {
    var l;
    clearTimeout(i), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, u) {
    l === void 0 && (l = !1), u === void 0 && (u = 1), r();
    const {
      left: c,
      top: f,
      width: m,
      height: w
    } = e.getBoundingClientRect();
    if (l || t(), !m || !w)
      return;
    const d = le(f), a = le(o.clientWidth - (c + m)), v = le(o.clientHeight - (f + w)), g = le(c), y = {
      rootMargin: -d + "px " + -a + "px " + -v + "px " + -g + "px",
      threshold: q(0, Z(1, u)) || 1
    };
    let b = !0;
    function C(O) {
      const A = O[0].intersectionRatio;
      if (A !== u) {
        if (!b)
          return s();
        A ? s(!1, A) : i = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...y,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, y);
    }
    n.observe(e);
  }
  return s(!0), r;
}
function dn(e, t, n, i) {
  i === void 0 && (i = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: r = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = i, c = Te(e), f = o || r ? [...c ? ie(c) : [], ...ie(t)] : [];
  f.forEach((h) => {
    o && h.addEventListener("scroll", n, {
      passive: !0
    }), r && h.addEventListener("resize", n);
  });
  const m = c && l ? fn(c, n) : null;
  let w = -1, d = null;
  s && (d = new ResizeObserver((h) => {
    let [y] = h;
    y && y.target === c && d && (d.unobserve(t), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      var b;
      (b = d) == null || b.observe(t);
    })), n();
  }), c && !u && d.observe(c), d.observe(t));
  let a, v = u ? G(e) : null;
  u && g();
  function g() {
    const h = G(e);
    v && (h.x !== v.x || h.y !== v.y || h.width !== v.width || h.height !== v.height) && n(), v = h, a = requestAnimationFrame(g);
  }
  return n(), () => {
    var h;
    f.forEach((y) => {
      o && y.removeEventListener("scroll", n), r && y.removeEventListener("resize", n);
    }), m == null || m(), (h = d) == null || h.disconnect(), d = null, u && cancelAnimationFrame(a);
  };
}
const mn = Ut, pn = Wt, vn = Xt, gn = It, hn = Vt, wn = Ht, yn = (e, t, n) => {
  const i = /* @__PURE__ */ new Map(), o = {
    platform: un,
    ...n
  }, r = {
    ...o.platform,
    _c: i
  };
  return _t(e, t, {
    ...o,
    platform: r
  });
};
function xn(e) {
  return tt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function bn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function tt(e) {
  return e instanceof Node || e instanceof bn(e).Node;
}
function Cn(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function xe(e) {
  if (Cn(e)) {
    const t = e.$el;
    return tt(t) && xn(t) === "#comment" ? null : t;
  }
  return e;
}
function On(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = xe(H(e.element));
      return n == null ? {} : wn({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function nt(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _e(e, t) {
  const n = nt(e);
  return Math.round(t * n) / n;
}
function An(e, t, n) {
  n === void 0 && (n = {});
  const i = n.whileElementsMounted, o = P(() => {
    var p;
    return (p = H(n.open)) != null ? p : !0;
  }), r = P(() => H(n.middleware)), s = P(() => {
    var p;
    return (p = H(n.placement)) != null ? p : "bottom";
  }), l = P(() => {
    var p;
    return (p = H(n.strategy)) != null ? p : "absolute";
  }), u = P(() => {
    var p;
    return (p = H(n.transform)) != null ? p : !0;
  }), c = P(() => xe(e.value)), f = P(() => xe(t.value)), m = R(0), w = R(0), d = R(l.value), a = R(s.value), v = We({}), g = R(!1), h = P(() => {
    const p = {
      position: d.value,
      left: "0",
      top: "0"
    };
    if (!f.value)
      return p;
    const T = _e(f.value, m.value), F = _e(f.value, w.value);
    return u.value ? {
      ...p,
      transform: "translate(" + T + "px, " + F + "px)",
      ...nt(f.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: d.value,
      left: T + "px",
      top: F + "px"
    };
  });
  let y;
  function b() {
    c.value == null || f.value == null || yn(c.value, f.value, {
      middleware: r.value,
      placement: s.value,
      strategy: l.value
    }).then((p) => {
      m.value = p.x, w.value = p.y, d.value = p.strategy, a.value = p.placement, v.value = p.middlewareData, g.value = !0;
    });
  }
  function C() {
    typeof y == "function" && (y(), y = void 0);
  }
  function O() {
    if (C(), i === void 0) {
      b();
      return;
    }
    if (c.value != null && f.value != null) {
      y = i(c.value, f.value, b);
      return;
    }
  }
  function A() {
    o.value || (g.value = !1);
  }
  return k([r, s, l], b, {
    flush: "sync"
  }), k([c, f], O, {
    flush: "sync"
  }), k(o, A, {
    flush: "sync"
  }), lt() && at(C), {
    x: Q(m),
    y: Q(w),
    strategy: Q(d),
    placement: Q(a),
    middlewareData: Q(v),
    isPositioned: Q(g),
    floatingStyles: h,
    update: b
  };
}
var Tn = Object.defineProperty, Sn = (e, t, n) => t in e ? Tn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, En = (e, t, n) => (Sn(e, typeof t != "symbol" ? t + "" : t, n), n);
function re(e) {
  return e == null || e.value == null ? null : e.value instanceof Node ? e.value : "$el" in e.value && e.value.$el ? re(R(e.value.$el)) : "getBoundingClientRect" in e.value ? e.value : null;
}
function ot(e) {
  return e.reduce((t, n) => n.type === Ie ? t.concat(ot(n.children)) : t.concat(n), []);
}
function Rn(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
function He(e) {
  return e = H(e), e && (e == null ? void 0 : e.nodeType) !== Node.COMMENT_NODE;
}
class Pn {
  constructor() {
    En(this, "current", this.detect());
  }
  set(t) {
    this.current !== t && (this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
const Ee = new Pn();
function Fn(e) {
  if (Ee.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (Object.prototype.hasOwnProperty.call(e, "value")) {
    const t = re(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
function Ln(e, t) {
  !t.vueTransition && (t.transitionName || t.transitionType) && console.warn(`[headlessui-float]: <${e} /> pass "transition-name" or "transition-type" prop, must be set "vue-transition" prop.`);
}
function Bn(e, t, n, i, o) {
  k([
    () => o.offset,
    () => o.flip,
    () => o.shift,
    () => o.autoPlacement,
    () => o.arrow,
    () => o.hide,
    () => o.middleware
  ], () => {
    const r = [];
    (typeof o.offset == "number" || typeof o.offset == "object" || typeof o.offset == "function") && r.push(mn(o.offset)), (o.flip === !0 || typeof o.flip == "number" || typeof o.flip == "object") && r.push(gn({
      padding: typeof o.flip == "number" ? o.flip : void 0,
      ...typeof o.flip == "object" ? o.flip : {}
    })), (o.shift === !0 || typeof o.shift == "number" || typeof o.shift == "object") && r.push(vn({
      padding: typeof o.shift == "number" ? o.shift : void 0,
      ...typeof o.shift == "object" ? o.shift : {}
    })), (o.autoPlacement === !0 || typeof o.autoPlacement == "object") && r.push(pn(
      typeof o.autoPlacement == "object" ? o.autoPlacement : void 0
    )), r.push(...typeof o.middleware == "function" ? o.middleware({
      referenceEl: t,
      floatingEl: n
    }) : o.middleware || []), (o.arrow === !0 || typeof o.arrow == "number") && r.push(On({
      element: i,
      padding: o.arrow === !0 ? 0 : o.arrow
    })), (o.hide === !0 || typeof o.hide == "object" || Array.isArray(o.hide)) && (Array.isArray(o.hide) ? o.hide : [o.hide]).forEach((s) => {
      r.push(hn(
        typeof s == "object" ? s : void 0
      ));
    }), e.value = r;
  }, { immediate: !0 });
}
function Dn(e, t, n) {
  let i = () => {
  };
  Ve(() => {
    if (e && Ee.isClient && typeof ResizeObserver < "u" && t.value && t.value instanceof Element) {
      const o = new ResizeObserver(([r]) => {
        n.value = r.borderBoxSize.reduce((s, { inlineSize: l }) => s + l, 0);
      });
      o.observe(t.value), i = () => {
        o.disconnect(), n.value = null;
      };
    }
  }), ft(() => {
    i();
  });
}
const Nn = (e) => {
  switch (e) {
    case "top":
      return "origin-bottom";
    case "bottom":
      return "origin-top";
    case "left":
      return "origin-right";
    case "right":
      return "origin-left";
    case "top-start":
    case "right-end":
      return "origin-bottom-left";
    case "top-end":
    case "left-end":
      return "origin-bottom-right";
    case "right-start":
    case "bottom-start":
      return "origin-top-left";
    case "left-start":
    case "bottom-end":
      return "origin-top-right";
    default:
      return "origin-center";
  }
};
function $n(e, t) {
  const n = P(() => {
    if (typeof e.originClass == "function")
      return e.originClass(t.value);
    if (typeof e.originClass == "string")
      return e.originClass;
    if (e.tailwindcssOriginClass)
      return Nn(t.value);
  }), i = P(
    () => e.enter || n.value ? `${e.enter || ""} ${n.value || ""}` : void 0
  ), o = P(
    () => e.leave || n.value ? `${e.leave || ""} ${n.value || ""}` : void 0
  );
  return { originClassRef: n, enterActiveClassRef: i, leaveActiveClassRef: o };
}
function it(e, t, ...n) {
  if (e in t) {
    const o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  const i = new Error(
    `Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(
      t
    ).map((o) => `"${o}"`).join(", ")}.`
  );
  throw Error.captureStackTrace && Error.captureStackTrace(i, it), i;
}
const Me = [
  "[contentEditable=true]",
  "[tabindex]",
  "a[href]",
  "area[href]",
  "button:not([disabled])",
  "iframe",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])"
].map(
  // TODO: Remove this once JSDOM fixes the issue where an element that is
  // "hidden" can be the document.activeElement, because this is not possible
  // in real browsers.
  (e) => `${e}:not([tabindex='-1'])`
).join(",");
var rt = /* @__PURE__ */ ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(rt || {});
function kn(e, t = 0) {
  var n;
  return e === ((n = Fn(e)) == null ? void 0 : n.body) ? !1 : it(t, {
    0() {
      return e.matches(Me);
    },
    1() {
      let i = e;
      for (; i !== null; ) {
        if (i.matches(Me))
          return !0;
        i = i.parentElement;
      }
      return !1;
    }
  });
}
function we(e, t, n) {
  Ee.isServer || dt((i) => {
    document.addEventListener(e, t, n), i(() => document.removeEventListener(e, t, n));
  });
}
function jn(e, t, n = P(() => !0)) {
  function i(r, s) {
    if (!n.value || r.defaultPrevented)
      return;
    const l = s(r);
    if (l === null || !l.getRootNode().contains(l))
      return;
    const u = function c(f) {
      return typeof f == "function" ? c(f()) : Array.isArray(f) || f instanceof Set ? f : [f];
    }(e);
    for (const c of u) {
      if (c === null)
        continue;
      const f = c instanceof HTMLElement ? c : re(c);
      if (f != null && f.contains(l) || r.composed && r.composedPath().includes(f))
        return;
    }
    return (
      // This check alllows us to know whether or not we clicked on a "focusable" element like a
      // button or an input. This is a backwards compatibility check so that you can open a <Menu
      // /> and click on another <Menu /> which should close Menu A and open Menu B. We might
      // revisit that so that you will require 2 clicks instead.
      !kn(l, rt.Loose) && // This could be improved, but the `Combobox.Button` adds tabIndex={-1} to make it
      // unfocusable via the keyboard so that tabbing to the next item from the input doesn't
      // first go to the button.
      l.tabIndex !== -1 && r.preventDefault(), t(r, l)
    );
  }
  const o = R(null);
  we("mousedown", (r) => {
    var s, l;
    n.value && (o.value = ((l = (s = r.composedPath) == null ? void 0 : s.call(r)) == null ? void 0 : l[0]) || r.target);
  }, !0), we(
    "click",
    (r) => {
      o.value && (i(r, () => o.value), o.value = null);
    },
    // We will use the `capture` phase so that layers in between with `event.stopPropagation()`
    // don't "cancel" this outside click check. E.g.: A `Menu` inside a `DialogPanel` if the `Menu`
    // is open, and you click outside of it in the `DialogPanel` the `Menu` should close. However,
    // the `DialogPanel` has a `onClick(e) { e.stopPropagation() }` which would cancel this.
    !0
  ), we("blur", (r) => i(
    r,
    () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null
  ), !0);
}
const _n = Symbol("ArrowContext"), x = {
  as: {
    type: [String, Function],
    default: "template"
  },
  floatingAs: {
    type: [String, Function],
    default: "div"
  },
  show: {
    type: Boolean,
    default: null
  },
  placement: {
    type: String,
    default: "bottom-start"
  },
  strategy: {
    type: String,
    default: "absolute"
  },
  offset: [Number, Function, Object],
  shift: {
    type: [Boolean, Number, Object],
    default: !1
  },
  flip: {
    type: [Boolean, Number, Object],
    default: !1
  },
  arrow: {
    type: [Boolean, Number],
    default: !1
  },
  autoPlacement: {
    type: [Boolean, Object],
    default: !1
  },
  hide: {
    type: [Boolean, Object, Array],
    default: !1
  },
  referenceHiddenClass: String,
  escapedClass: String,
  autoUpdate: {
    type: [Boolean, Object],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 9999
  },
  vueTransition: {
    type: Boolean,
    default: !1
  },
  transitionName: String,
  transitionType: String,
  enter: String,
  enterFrom: String,
  enterTo: String,
  leave: String,
  leaveFrom: String,
  leaveTo: String,
  originClass: [String, Function],
  tailwindcssOriginClass: {
    type: Boolean,
    default: !1
  },
  portal: {
    type: Boolean,
    default: !1
  },
  transform: {
    type: Boolean,
    default: !1
  },
  adaptiveWidth: {
    type: [Boolean, Object],
    default: !1
  },
  composable: {
    type: Boolean,
    default: !1
  },
  dialog: {
    type: Boolean,
    default: !1
  },
  middleware: {
    type: [Array, Function],
    default: () => []
  }
};
function Hn(e, t, n, i) {
  const { floatingRef: o, props: r, mounted: s, show: l, referenceHidden: u, escaped: c, placement: f, floatingStyles: m, referenceElWidth: w, updateFloating: d } = i, a = pe(
    { ...r, as: r.floatingAs },
    t
  ), { enterActiveClassRef: v, leaveActiveClassRef: g } = $n(a, f), h = {
    show: s.value ? a.show : !1,
    enter: v.value,
    enterFrom: a.enterFrom,
    enterTo: a.enterTo,
    leave: g.value,
    leaveFrom: a.leaveFrom,
    leaveTo: a.leaveTo,
    onBeforeEnter() {
      l.value = !0;
    },
    onAfterLeave() {
      l.value = !1;
    }
  }, y = {
    name: a.transitionName,
    type: a.transitionType,
    appear: !0,
    ...a.transitionName ? {} : {
      enterActiveClass: v.value,
      enterFromClass: a.enterFrom,
      enterToClass: a.enterTo,
      leaveActiveClass: g.value,
      leaveFromClass: a.leaveFrom,
      leaveToClass: a.leaveTo
    },
    onBeforeEnter() {
      l.value = !0;
    },
    onAfterLeave() {
      l.value = !1;
    }
  }, b = {
    class: [
      u.value ? a.referenceHiddenClass : void 0,
      c.value ? a.escapedClass : void 0
    ].filter((p) => !!p).join(" "),
    style: {
      ...m.value,
      zIndex: a.zIndex
    }
  };
  if (a.adaptiveWidth && typeof w.value == "number") {
    const p = {
      attribute: "width",
      ...typeof a.adaptiveWidth == "object" ? a.adaptiveWidth : {}
    };
    b.style[p.attribute] = `${w.value}px`;
  }
  function C(p) {
    return a.portal ? s.value ? ne(mt, () => p) : ve() : p;
  }
  function O(p) {
    const T = pe(
      b,
      n,
      a.dialog ? {} : { ref: o }
    );
    return a.as === "template" ? p : typeof a.as == "string" ? ne(a.as, T, p) : ne(a.as, T, () => p);
  }
  function A() {
    function p() {
      var T;
      const F = a.as === "template" ? pe(
        b,
        n,
        a.dialog ? {} : { ref: o }
      ) : null, E = ht(e, F);
      return ((T = e.props) == null ? void 0 : T.unmount) === !1 ? (d(), E) : a.vueTransition && a.show === !1 ? ve() : E;
    }
    return s.value ? a.vueTransition ? ne(pt, {
      ...a.dialog ? { ref: o } : {},
      ...y
    }, p) : ne(a.transitionChild ? vt : gt, {
      key: `placement-${f.value}`,
      ...a.dialog ? { ref: o } : {},
      as: "template",
      ...h
    }, p) : ve();
  }
  return C(
    O(
      A()
    )
  );
}
function Mn(e, t, n, i, o) {
  const r = R(!1), s = Re(i, "placement"), l = Re(i, "strategy"), u = We({}), c = R(void 0), f = R(void 0), m = R(null), w = R(void 0), d = R(void 0), a = P(() => re(t)), v = P(() => re(n)), g = P(
    () => He(a) && He(v)
  ), { placement: h, middlewareData: y, isPositioned: b, floatingStyles: C, update: O } = An(a, v, {
    placement: s,
    strategy: l,
    middleware: u,
    // If enable dialog mode, then set `transform` to false.
    transform: i.dialog ? !1 : i.transform,
    // Fix transition not smooth bug when dialog mode enabled.
    whileElementsMounted: i.dialog ? () => () => {
    } : void 0
  }), A = R(null);
  Ve(() => {
    r.value = !0;
  }), k(e, (S, D) => {
    S && !D ? o("show") : !S && D && o("hide");
  }, { immediate: !0 });
  function p() {
    g.value && (O(), o("update"));
  }
  k([s, l, u], p, { flush: "sync" }), Bn(
    u,
    a,
    v,
    m,
    i
  ), k([y, () => i.hide, b], () => {
    var S, D;
    (i.hide === !0 || typeof i.hide == "object" || Array.isArray(i.hide)) && (c.value = ((S = y.value.hide) == null ? void 0 : S.referenceHidden) || !b.value, f.value = (D = y.value.hide) == null ? void 0 : D.escaped);
  }), k(y, () => {
    const S = y.value.arrow;
    w.value = S == null ? void 0 : S.x, d.value = S == null ? void 0 : S.y;
  }), Dn(!!i.adaptiveWidth, a, A), k([e, g], async (S, D, L) => {
    if (await ct(), e.value && g.value && i.autoUpdate) {
      const $ = dn(
        a.value,
        v.value,
        p,
        typeof i.autoUpdate == "object" ? i.autoUpdate : void 0
      );
      L($);
    }
  }, { flush: "post", immediate: !0 });
  const T = R(!0);
  k(a, () => {
    !(a.value instanceof Element) && g.value && T.value && (T.value = !1, window.requestAnimationFrame(() => {
      T.value = !0, p();
    }));
  }, { flush: "sync" });
  const F = {
    referenceRef: t,
    placement: h
  }, E = {
    floatingRef: n,
    props: i,
    mounted: r,
    show: e,
    referenceHidden: c,
    escaped: f,
    placement: h,
    floatingStyles: C,
    referenceElWidth: A,
    updateFloating: p
  }, B = {
    ref: m,
    placement: h,
    x: w,
    y: d
  };
  return ut(_n, B), { referenceApi: F, floatingApi: E, arrowApi: B, placement: h, referenceEl: a, floatingEl: v, middlewareData: y, update: p };
}
({
  ...x.as
});
const Wn = {
  as: x.as,
  show: x.show,
  placement: x.placement,
  strategy: x.strategy,
  offset: x.offset,
  shift: x.shift,
  flip: x.flip,
  arrow: x.arrow,
  autoPlacement: x.autoPlacement,
  autoUpdate: x.autoUpdate,
  zIndex: x.zIndex,
  vueTransition: x.vueTransition,
  transitionName: x.transitionName,
  transitionType: x.transitionType,
  enter: x.enter,
  enterFrom: x.enterFrom,
  enterTo: x.enterTo,
  leave: x.leave,
  leaveFrom: x.leaveFrom,
  leaveTo: x.leaveTo,
  originClass: x.originClass,
  tailwindcssOriginClass: x.tailwindcssOriginClass,
  portal: x.portal,
  transform: x.transform,
  middleware: x.middleware
}, In = {
  name: "FloatVirtual",
  inheritAttrs: !1,
  props: Wn,
  emits: ["initial", "show", "hide", "update"],
  setup(e, { emit: t, slots: n, attrs: i }) {
    Ln("FloatVirtual", e);
    const o = R(e.show ?? !1), r = R({
      getBoundingClientRect() {
        return {
          x: 0,
          y: 0,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: 0,
          height: 0
        };
      }
    }), s = R(null), {
      floatingApi: l,
      placement: u
    } = Mn(o, r, s, e, t);
    k(() => e.show, () => {
      o.value = e.show ?? !1;
    });
    function c() {
      o.value = !1;
    }
    return t("initial", {
      show: o,
      placement: u,
      reference: r,
      floating: s
    }), () => {
      if (!n.default)
        return;
      const f = {
        placement: u.value,
        close: c
      }, [m] = ot(n.default(f)).filter(Rn);
      return Hn(
        m,
        {
          as: e.as,
          show: o.value
        },
        i,
        l
      );
    };
  }
};
x.as, x.placement, x.strategy, x.offset, x.shift, {
  ...x.flip
}, x.arrow, x.autoPlacement, x.autoUpdate, x.zIndex, x.vueTransition, x.transitionName, x.transitionType, x.enter, x.enterFrom, x.enterTo, x.leave, x.leaveFrom, x.leaveTo, x.originClass, x.tailwindcssOriginClass, x.transform, x.middleware;
const Vn = { class: "flex bg-white shadow-md z-10 rounded-md p-1" }, zn = ["onClick"], Xn = /* @__PURE__ */ wt({
  __name: "StylePanel",
  setup(e) {
    yt({ WATCH_ARRAY: !1 });
    const t = R({ value: null }), n = xt(), i = P(
      () => n.getters.onContentChange || (() => {
      })
    ), o = P(
      () => bt(n.getters.diagramElement) + Ct
    ), r = P(() => n.getters.code), s = (m) => {
      n.dispatch("updateCode", { code: m }), i.value(m);
    }, l = R([]);
    let u;
    const c = ({ show: m, reference: w, floating: d }) => {
      let a, v, g, h, y, b;
      n.commit("onMessageClick", (C, O) => {
        var A;
        if (a = C.value.start.start, v = Pt(r.value, a), g = Ft(r.value, a), h = ((A = r.value.slice(v).match(/^\s*/)) == null ? void 0 : A[0]) || "", y = g.trim().startsWith("//"), y) {
          const p = g.trimStart().slice(2).trimStart(), T = p.indexOf("["), F = p.indexOf("]");
          b = !!(T === 0 && F), b ? l.value = p.slice(T + 1, F).split(",").map((E) => E.trim()) : l.value = [];
        }
        w.value = {
          getBoundingClientRect: () => O.getBoundingClientRect()
        }, t.value = C, m.value = !0;
      }), jn(
        d,
        () => {
          m.value = !1, l.value = [];
        },
        P(() => m.value)
      ), u = (C) => {
        var O;
        if (m.value = !1, !!t.value.value)
          if (y) {
            let A = "";
            if (b) {
              let p;
              l.value.includes(C) ? p = l.value.filter((T) => T !== C) : p = [...l.value, C], A = `${h}// [${p.filter(Boolean).join(", ")}] ${g.slice(g.indexOf("]") + 1).trimStart()}`;
            } else
              A = `${h}// [${C}] ${g.slice((((O = g.match(/\/\/*/)) == null ? void 0 : O.index) || -2) + 2).trimStart()}`;
            A.endsWith(`
`) || (A += `
`), s(
              r.value.slice(0, Lt(r.value, a)) + A + r.value.slice(v)
            );
          } else
            s(
              r.value.slice(0, v) + `${h}// [${C}]
` + r.value.slice(v)
            );
      };
    }, f = [
      {
        name: "bold",
        content: "B",
        class: "font-bold"
      },
      {
        name: "italic",
        content: "I",
        class: "italic"
      },
      {
        name: "underline",
        content: "U",
        class: "underline"
      },
      {
        name: "strikethrough",
        content: "S",
        class: "line-through"
      }
    ];
    return (m, w) => (Pe(), Ot(H(In), {
      "vue-transition": "",
      id: "style-panel",
      key: "tool",
      onInitial: c,
      placement: "top",
      offset: 5,
      flip: { padding: H(o) },
      shift: "",
      zIndex: "30"
    }, {
      default: At(() => [
        ge("div", Vn, [
          (Pe(), Tt(Ie, null, St(f, (d) => ge("div", {
            onClick: () => H(u)(d.class),
            key: d.name
          }, [
            ge("div", {
              class: Et(["w-6 mx-1 py-1 rounded-md text-black text-center cursor-pointer hover:bg-gray-200", [
                d.class,
                { "bg-gray-100": l.value.includes(d.class) }
              ]])
            }, Rt(d.content), 3)
          ], 8, zn)), 64))
        ])
      ], void 0, !0),
      _: 1
    }, 8, ["flip"]));
  }
});
export {
  Xn as default
};
//# sourceMappingURL=StylePanel-c6e01b46.js.map
